var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.loading)?_c('div',{staticClass:"page"},[_c('b-spinner',{key:"primary",staticClass:"spinner",attrs:{"variant":"primary"}})],1):_vm._e(),_c('RouterView'),_c('ServerErrorDialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }